module.exports = __webpack_public_path__ + "img/rope-math2.768f0e16.png";